"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsupportedStackingTypes = exports.sortedByMeasureTypes = exports.unsupportedNegativeValuesTypes = exports.multiMeasuresAlternatingTypes = exports.supportedStackingAttributesChartTypes = exports.supportedTooltipFollowPointerChartTypes = exports.supportedDualAxesChartTypes = void 0;
// (C) 2020 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
exports.supportedDualAxesChartTypes = [
    sdk_ui_1.VisualizationTypes.COLUMN,
    sdk_ui_1.VisualizationTypes.BAR,
    sdk_ui_1.VisualizationTypes.BULLET,
    sdk_ui_1.VisualizationTypes.LINE,
    sdk_ui_1.VisualizationTypes.AREA,
    sdk_ui_1.VisualizationTypes.COMBO,
    sdk_ui_1.VisualizationTypes.COMBO2,
];
exports.supportedTooltipFollowPointerChartTypes = [
    sdk_ui_1.VisualizationTypes.COLUMN,
    sdk_ui_1.VisualizationTypes.BAR,
    sdk_ui_1.VisualizationTypes.BULLET,
    sdk_ui_1.VisualizationTypes.COMBO,
    sdk_ui_1.VisualizationTypes.COMBO2,
];
exports.supportedStackingAttributesChartTypes = [
    sdk_ui_1.VisualizationTypes.COLUMN,
    sdk_ui_1.VisualizationTypes.BAR,
    sdk_ui_1.VisualizationTypes.BULLET,
    sdk_ui_1.VisualizationTypes.AREA,
    sdk_ui_1.VisualizationTypes.COMBO,
    sdk_ui_1.VisualizationTypes.COMBO2,
];
// types with only many measures or one measure and one attribute
exports.multiMeasuresAlternatingTypes = [
    sdk_ui_1.VisualizationTypes.PIE,
    sdk_ui_1.VisualizationTypes.DONUT,
    sdk_ui_1.VisualizationTypes.FUNNEL,
    sdk_ui_1.VisualizationTypes.TREEMAP,
];
exports.unsupportedNegativeValuesTypes = [
    sdk_ui_1.VisualizationTypes.PIE,
    sdk_ui_1.VisualizationTypes.DONUT,
    sdk_ui_1.VisualizationTypes.FUNNEL,
    sdk_ui_1.VisualizationTypes.TREEMAP,
];
// charts sorted by default by measure value
exports.sortedByMeasureTypes = [
    sdk_ui_1.VisualizationTypes.PIE,
    sdk_ui_1.VisualizationTypes.DONUT,
    sdk_ui_1.VisualizationTypes.FUNNEL,
];
exports.unsupportedStackingTypes = [
    sdk_ui_1.VisualizationTypes.LINE,
    sdk_ui_1.VisualizationTypes.AREA,
    sdk_ui_1.VisualizationTypes.SCATTER,
    sdk_ui_1.VisualizationTypes.BUBBLE,
];
//# sourceMappingURL=chartCapabilities.js.map